import api, { apiPrefix } from './Api';
import { Pagination, paginationToParams } from '../interfaces/Pagination';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import { Refund, refundFromResponse } from '../interfaces/Refund/Refund';

const refundsApiPrefix = `${apiPrefix}/refunds`;

export const getRefunds = async (
  pagination: Pagination,
): Promise<PaginatedResponse<Refund>> => {
  const response = await api.get(refundsApiPrefix, {
    params: paginationToParams(pagination),
  });

  return {
    data: (response.data?.data ?? []).map(refundFromResponse),
    totalCount: response.data?.total_count ?? 0,
  };
};
